import React, { lazy } from 'react';
const InboxDashboard = lazy(() => import('../containers/Inbox/InboxDashboard'));
function ChatRouts() {
    return React.createElement(InboxDashboard, null);
}
export default ChatRouts;
